import React from "react";
import Header from "../components/header/header"
import Footer from "../components/footer/footer";

function Layout({ children }) {
  return (
    <div>
      <Header />
      <div>{children}</div>
      <Footer />
    </div>
  );
}

export default Layout;
